import React from 'react'
import AddTaskIcon from '@mui/icons-material/AddTask';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import warehouseIco from '../../../assets/img/ico/warehouse.svg'
import productionIco from '../../../assets/img/ico/production.svg'
import taskListIco from '../../../assets/img/ico/task-list.svg'
import deliveryIco from '../../../assets/img/ico/delivery.svg'
import SidebarItem from './SidebarItem';
import { getCategoryAccessCategory, getFirstAccessPathInCategory } from '../../../helpers/user/UserHelper';
import { useSelector } from 'react-redux';
import userIco from '../../../assets/img/ico/user.svg'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const SidebarMenuDown = () => {

    const user = useSelector(state => state.user.user)

    const menuList = [
        {
            category: '/user',
            // url: '/packs', // Тут підставляється автоматично з дозволів
            title: 'Обліковий запис',
            // imgSrc: userIco
            imgSrc: <AccountCircleIcon />,
            isIco: true
        },
    ]

    const isActive = (category) => {
        let active = false

        if (window) {
            if (window.location.pathname.includes(category)) {
                active = true
            }
        }

        return active
    }

    const isAccess = (category) => {
        let access = false

        access = getCategoryAccessCategory ({ 
            // path: window.location.pathname, 
            permissions: user && user.permissions ? user.permissions : null,
            categoryName: category
        })

        return access
    }

  return (
    <div className='sidebarMenu__main'>
        <ul>
            {
                menuList && menuList.length > 0 ?
                    menuList.map(item => {
                        const firstPath = getFirstAccessPathInCategory({
                            permissions: user && user.permissions ? user.permissions : null,
                            categoryName: item.category
                        })
                        if (isAccess(item.category)) {
                            return <SidebarItem 
                                key={item.category + firstPath}
                                url={item.category + firstPath}
                                title={item.title}
                                imgSrc={item.imgSrc}
                                isIco={item.isIco}
                                active={isActive(item.category)}
                            />
                        }
                    })
                : ''
            }
        </ul>
    </div>
  )
}

export default SidebarMenuDown